// Mapping of figma variables to json object (2025-12-10)
// Figma file: https://www.figma.com/design/sontXo1awBOKc2rVVldSr2/BEA-01-%E2%80%94%C2%A0UI-%E2%80%94-Primary?node-id=15341-94710&p=f&t=VrKxOuzLQWU01QGn-0

export const colours = {
    'swatch': {
        'brand-400'            : '#364896ff',
        'brand-500'            : '#24148aff',
        'brand-700'            : '#1c1069ff',
        'grey-dark-600'        : '#767675ff',
        'grey-dark-700'        : '#4b4a49ff',
        'grey-dark-800'        : '#2c2b2aff',
        'grey-dark-900'        : '#242320ff',
        'grey-grey-0'          : '#ffffffff',
        'grey-grey-100'        : '#f8f7f6ff',
        'grey-grey-200'        : '#edece8ff',
        'grey-grey-300'        : '#deddd9ff',
        'grey-grey-400'        : '#a4a3a1ff',
        'grey-grey-50'         : '#fcfcfaff',
        'grey-grey-950'        : '#141412ff',
        'grey-grey-transparent': '#ffffff00',
        'sand-200'             : '#f7f6f2ff',
        'system-fail'          : '#e84221ff',
        'system-success'       : '#538755ff',
        'tint-dark'            : '#131214',
        'tint-dark-10'         : '#1312141a',
        'tint-dark-15'         : '#13121426',
        'tint-dark-20'         : '#13121433',
        'tint-dark-40'         : '#13121466',
        'tint-dark-60'         : '#13121499',
        'tint-dark-80'         : '#131214cc',
        'tint-dark-90'         : '#131214e5',
        'tint-light-10'        : '#ffffff1a',
        'tint-light-15'        : '#ffffff26',
        'tint-light-20'        : '#ffffff33',
        'tint-light-40'        : '#ffffff66',
        'tint-light-60'        : '#ffffff99',
        'tint-light-80'        : '#ffffffcc',
        'tint-light-90'        : '#ffffffe5'
    },
    'theme-light': {
        'button-brand-filled-background'               : 'var(--brand-500)',
        'button-brand-filled-background-hover'         : 'var(--brand-400)',
        'button-brand-filled-text'                     : 'var(--grey-grey-200)',
        'button-brand-filled-text-hover'               : 'var(--grey-grey-50)',
        'button-brand-transparent-background'          : 'var(--grey-grey-transparent)',
        'button-brand-transparent-background-hover'    : 'var(--brand-500)',
        'button-brand-transparent-text'                : 'var(--main-text-primary)',
        'button-brand-transparent-text-hover'          : 'var(--grey-grey-50)',
        'button-primary-filled-background'             : 'var(--grey-dark-700)',
        'button-primary-filled-background-hover'       : 'var(--grey-dark-600)',
        'button-primary-filled-text'                   : 'var(--grey-grey-50)',
        'button-primary-filled-text-hover'             : 'var(--grey-grey-50)',
        'button-primary-transparent-background'        : 'var(--grey-grey-transparent)',
        'button-primary-transparent-background-hover'  : 'var(--grey-dark-600)',
        'button-primary-transparent-text'              : 'var(--main-text-primary)',
        'button-primary-transparent-text-hover'        : 'var(--grey-grey-50)',
        'button-secondary-filled-background'           : 'var(--grey-grey-200)',
        'button-secondary-filled-background-hover'     : 'var(--grey-grey-300)',
        'button-secondary-filled-text'                 : 'var(--main-text-primary)',
        'button-secondary-filled-text-hover'           : 'var(--main-text-primary)',
        'button-secondary-transparent-background'      : 'var(--grey-grey-transparent)',
        'button-secondary-transparent-background-hover': 'var(--grey-grey-300)',
        'button-secondary-transparent-text'            : 'var(--main-text-primary)',
        'button-secondary-transparent-text-hover'      : 'var(--main-text-primary)',
        'filter-background'                            : 'var(--grey-grey-100)',
        'filter-background-hover'                      : 'var(--tint-light-90)',
        'filter-border-active'                         : 'var(--grey-grey-200)',
        'filter-filled-text'                           : 'var(--main-text-primary)',
        'filter-label'                                 : 'var(--main-text-primary)',
        'input-background'                             : 'var(--grey-grey-100)',
        'input-background-hover'                       : 'var(--grey-grey-200)',
        'input-border'                                 : 'var(--grey-grey-200)',
        'input-border-active'                          : 'var(--grey-grey-300)',
        'input-filled-text'                            : 'var(--main-text-primary)',
        'input-label'                                  : 'var(--main-text-primary)',
        'main-background'                              : 'var(--grey-grey-0)',
        'main-background-alt'                          : 'var(--sand-sand-200)',
        'main-background-brand'                        : 'var(--brand-500)',
        'main-border'                                  : 'var(--tint-dark-15)',
        'main-brand-text'                              : 'var(--brand-700)',
        'main-logo'                                    : 'var(--main-brand-text)',
        'main-text-primary'                            : 'var(--grey-dark-900)',
        'main-text-secondary'                          : 'var(--grey-dark-700)',
        'nav-item-divider'                             : 'var(--tint-dark-20)',
        'nav-item-underline'                           : 'var(--tint-dark-40)',
        'system-fail'                                  : 'var(--system-fail)',
        'system-success'                               : 'var(--system-success)',
        'tab-background'                               : 'var(--grey-grey-transparent)',
        'tab-background-hover'                         : 'var(--grey-grey-300)',
        'tab-background-selected'                      : 'var(--grey-grey-200)',
        'tab-border'                                   : 'var(--grey-grey-transparent)',
        'tab-border-hover'                             : 'var(--grey-grey-transparent)',
        'tab-border-selected'                          : 'var(--grey-grey-transparent)',
        'tab-text'                                     : 'var(--main-text-secondary)',
        'tab-text-hover'                               : 'var(--main-text-primary)',
        'tab-text-selected'                            : 'var(--main-text-primary)',
        'tag-main-background'                          : 'var(--grey-grey-100)',
        'tag-main-background-hover'                    : 'var(--grey-grey-300)',
        'tag-main-background-selected-brand'           : 'var(--brand-500)',
        'tag-main-background-selected-primary'         : 'var(--grey-dark-700)',
        'tag-main-background-selected-secondary'       : 'var(--grey-grey-200)',
        'tag-main-border'                              : 'var(--grey-grey-transparent)',
        'tag-main-border-hover'                        : 'var(--grey-grey-transparent)',
        'tag-main-border-selected'                     : 'var(--grey-grey-transparent)',
        'tag-main-text'                                : 'var(--main-text-secondary)',
        'tag-main-text-hover'                          : 'var(--main-text-primary)',
        'tag-main-text-selected'                       : 'var(--grey-grey-100)',
        'tag-price-background'                         : 'var(--grey-grey-100)',
        'tooltip-background'                           : 'var(--grey-dark-700)',
        'tooltip-icon'                                 : 'var(--grey-grey-50)'
    },
    'theme-light-alt': {
        'button-brand-filled-background'               : 'var(--brand-500)',
        'button-brand-filled-background-hover'         : 'var(--brand-400)',
        'button-brand-filled-text'                     : 'var(--grey-grey-200)',
        'button-brand-filled-text-hover'               : 'var(--grey-grey-50)',
        'button-brand-transparent-background'          : 'var(--grey-grey-transparent)',
        'button-brand-transparent-background-hover'    : 'var(--grey-dark-600)',
        'button-brand-transparent-text'                : 'var(--main-text-primary)',
        'button-brand-transparent-text-hover'          : 'var(--grey-grey-50)',
        'button-primary-filled-background'             : 'var(--grey-dark-900)',
        'button-primary-filled-background-hover'       : 'var(--grey-dark-600)',
        'button-primary-filled-text'                   : 'var(--grey-grey-50)',
        'button-primary-filled-text-hover'             : 'var(--grey-grey-50)',
        'button-primary-transparent-background'        : 'var(--grey-grey-transparent)',
        'button-primary-transparent-background-hover'  : 'var(--grey-dark-600)',
        'button-primary-transparent-text'              : 'var(--main-text-primary)',
        'button-primary-transparent-text-hover'        : 'var(--grey-grey-50)',
        'button-secondary-filled-background'           : 'var(--grey-grey-0)',
        'button-secondary-filled-background-hover'     : 'var(--tint-light-80)',
        'button-secondary-filled-text'                 : 'var(--main-text-primary)',
        'button-secondary-filled-text-hover'           : 'var(--main-text-primary)',
        'button-secondary-transparent-background'      : 'var(--grey-grey-transparent)',
        'button-secondary-transparent-background-hover': 'var(--tint-light-80)',
        'button-secondary-transparent-text'            : 'var(--main-text-primary)',
        'button-secondary-transparent-text-hover'      : 'var(--main-text-primary)',
        'filter-background'                            : 'var(--grey-grey-0)',
        'filter-background-hover'                      : 'var(--tint-light-80)',
        'filter-border-active'                         : 'var(--grey-grey-200)',
        'filter-filled-text'                           : 'var(--main-text-primary)',
        'filter-label'                                 : 'var(--main-text-primary)',
        'input-background'                             : 'var(--grey-grey-50)',
        'input-background-hover'                       : 'var(--grey-grey-100)',
        'input-border'                                 : 'var(--grey-grey-200)',
        'input-border-active'                          : 'var(--grey-grey-300)',
        'input-filled-text'                            : 'var(--main-text-primary)',
        'input-label'                                  : 'var(--main-text-primary)',
        'main-background'                              : 'var(--sand-sand-200)',
        'main-background-alt'                          : 'var(--grey-grey-0)',
        'main-background-brand'                        : 'var(--brand-500)',
        'main-border'                                  : 'var(--tint-dark-20)',
        'main-brand-text'                              : 'var(--brand-500)',
        'main-logo'                                    : 'var(--main-brand-text)',
        'main-text-primary'                            : 'var(--grey-dark-900)',
        'main-text-secondary'                          : 'var(--grey-dark-700)',
        'nav-item-divider'                             : 'var(--tint-dark-20)',
        'nav-item-underline'                           : 'var(--tint-dark-40)',
        'system-fail-200'                              : 'var(--system-fail)',
        'system-success-200'                           : 'var(--system-success)',
        'tab-background'                               : 'var(--grey-grey-transparent)',
        'tab-background-hover'                         : 'var(--grey-grey-0)',
        'tab-background-selected'                      : 'var(--grey-grey-200)',
        'tab-border'                                   : 'var(--grey-grey-transparent)',
        'tab-border-hover'                             : 'var(--grey-grey-transparent)',
        'tab-border-selected'                          : 'var(--grey-grey-transparent)',
        'tab-text'                                     : 'var(--main-text-primary)',
        'tab-text-hover'                               : 'var(--main-text-primary)',
        'tab-text-selected'                            : 'var(--main-text-primary)',
        'tag-main-background'                          : 'var(--tint-light-90)',
        'tag-main-background-hover'                    : 'var(--grey-grey-0)',
        'tag-main-background-selected-brand'           : 'var(--brand-500)',
        'tag-main-background-selected-primary'         : 'var(--grey-dark-700)',
        'tag-main-background-selected-secondary'       : 'var(--grey-grey-0)',
        'tag-main-border'                              : 'var(--grey-grey-transparent)',
        'tag-main-border-hover'                        : 'var(--grey-grey-transparent)',
        'tag-main-border-selected'                     : 'var(--grey-grey-transparent)',
        'tag-main-text'                                : 'var(--main-text-primary)',
        'tag-main-text-hover'                          : 'var(--main-text-primary)',
        'tag-main-text-selected'                       : 'var(--grey-grey-100)',
        'tag-price-background'                         : 'var(--grey-grey-0)',
        'tooltip-background'                           : 'var(--grey-dark-900)',
        'tooltip-icon'                                 : 'var(--grey-grey-50)'
    },
    'theme-brand': {
        'button-brand-filled-background-hover'         : 'var(--tint-light-90)',
        'button-brand-filled-background'               : 'var(--grey-grey-0)',
        'button-brand-filled-text-hover'               : 'var(--grey-dark-800)',
        'button-brand-filled-text'                     : 'var(--grey-dark-800)',
        'button-brand-transparent-background-hover'    : 'var(--tint-light-90)',
        'button-brand-transparent-background'          : 'var(--grey-grey-transparent)',
        'button-brand-transparent-text-hover'          : 'var(--grey-dark-900)',
        'button-brand-transparent-text'                : 'var(--grey-grey-100)',
        'button-primary-filled-background-hover'       : 'var(--tint-light-90)',
        'button-primary-filled-background'             : 'var(--grey-grey-0)',
        'button-primary-filled-text-hover'             : 'var(--grey-dark-900)',
        'button-primary-filled-text'                   : 'var(--grey-dark-900)',
        'button-primary-transparent-background-hover'  : 'var(--tint-light-90)',
        'button-primary-transparent-background'        : 'var(--grey-grey-transparent)',
        'button-primary-transparent-text-hover'        : 'var(--grey-dark-900)',
        'button-primary-transparent-text'              : 'var(--main-text-primary)',
        'button-secondary-filled-background-hover'     : 'var(--tint-light-10)',
        'button-secondary-filled-background'           : 'var(--tint-light-20)',
        'button-secondary-filled-text-hover'           : 'var(--grey-grey-0)',
        'button-secondary-filled-text'                 : 'var(--grey-grey-100)',
        'button-secondary-transparent-background-hover': 'var(--tint-light-10)',
        'button-secondary-transparent-background'      : 'var(--grey-grey-transparent)',
        'button-secondary-transparent-text-hover'      : 'var(--grey-grey-0)',
        'button-secondary-transparent-text'            : 'var(--grey-grey-100)',
        'filter-background-hover'                      : 'var(--tint-light-60)',
        'filter-background'                            : 'var(--grey-grey-300)',
        'filter-border-active'                         : 'var(--grey-grey-200)',
        'filter-filled-text'                           : 'var(--grey-dark-900)',
        'filter-label'                                 : 'var(--grey-dark-700)',
        'input-background'                             : 'var(--tint-light-20)',
        'input-background-hover'                       : 'var(--tint-light-10)',
        'input-border-active'                          : 'var(--tint-light-40)',
        'input-border'                                 : 'var(--grey-grey-transparent)',
        'input-filled-text'                            : 'var(--grey-grey-50)',
        'input-label'                                  : 'var(--grey-grey-50)',
        'main-background-alt'                          : 'var(--brand-700)',
        'main-background-brand'                        : 'var(--brand-500)',
        'main-background'                              : 'var(--brand-500)',
        'main-border'                                  : 'var(--tint-light-40)',
        'main-brand-text'                              : 'var(--main-text-primary)',
        'main-logo'                                    : 'var(--main-text-primary)',
        'main-text-primary'                            : 'var(--grey-grey-100)',
        'main-text-secondary'                          : 'var(--grey-grey-200)',
        'nav-item-divider'                             : 'var(--tint-light-20)',
        'nav-item-underline'                           : 'var(--tint-light-40)',
        'system-fail-200'                              : 'var(--system-fail)',
        'system-success-200'                           : 'var(--system-success)',
        'tab-background-hover'                         : 'var(--tint-light-60)',
        'tab-background-selected'                      : 'var(--grey-grey-100)',
        'tab-background'                               : 'var(--tint-light-40)',
        'tab-border-hover'                             : 'var(--grey-grey-transparent)',
        'tab-border-selected'                          : 'var(--grey-grey-transparent)',
        'tab-border'                                   : 'var(--grey-grey-transparent)',
        'tab-text-hover'                               : 'var(--tag-main-text)',
        'tab-text-selected'                            : 'var(--grey-dark-900)',
        'tab-text'                                     : 'var(--main-brand-text)',
        'tag-main-background-hover'                    : 'var(--tint-light-60)',
        'tag-main-background-selected-brand'           : 'var(--grey-grey-100)',
        'tag-main-background-selected-primary'         : 'var(--grey-grey-100)',
        'tag-main-background-selected-secondary'       : 'var(--grey-grey-100)',
        'tag-main-background'                          : 'var(--tint-light-40)',
        'tag-main-border-hover'                        : 'var(--grey-grey-transparent)',
        'tag-main-border-selected'                     : 'var(--grey-grey-transparent)',
        'tag-main-border'                              : 'var(--grey-grey-transparent)',
        'tag-main-text-hover'                          : 'var(--tag-main-text)',
        'tag-main-text-selected'                       : 'var(--grey-dark-900)',
        'tag-main-text'                                : 'var(--main-brand-text)',
        'tag-price-background'                         : 'var(--tint-light-90)',
        'tooltip-background'                           : 'var(--grey-grey-0)',
        'tooltip-icon'                                 : 'var(--grey-dark-900)'
    }
};
